import { faChevronDown, faChevronRight, faCheckCircle, faTimesCircle, faSyncAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';

const BulkUploadStep3 = ({notSavedCount,updatedCount,savedCount,SavedProducts,UpdatedProducts,NotSavedProducts}) => {

    // State for toggling lists
    const [isItemsOpen, setIsItemsOpen] = useState(false);
    const [isSkippedOpen, setIsSkippedOpen] = useState(false);
    const [isUnmappedOpen, setIsUnmappedOpen] = useState(false);

    // Toggle functions
    const toggleItemsOpen = () => setIsItemsOpen(!isItemsOpen);
    const toggleSkippedOpen = () => setIsSkippedOpen(!isSkippedOpen);
    const toggleUnmappedOpen = () => setIsUnmappedOpen(!isUnmappedOpen);

    return (
        <div className='flex flex-col w-1/2 justify-center items-center'>
            {/* Saved Products Section */}
            <div className='flex items-center w-full justify-between cursor-pointer' onClick={toggleItemsOpen}>
                <h2 className='text-sm font-regular flex items-center'>
                    <FontAwesomeIcon icon={faCheckCircle} className='text-green-500 mr-2 w-4 h-4' />
                    Items Saved Successfully: {SavedProducts?.length || 0}
                </h2>
                <button className='ml-2 p-1'>
                    {isItemsOpen ? (
                        <FontAwesomeIcon icon={faChevronDown} className='w-3 h-3' />
                    ) : (
                        <FontAwesomeIcon icon={faChevronRight} className='w-3 h-3' />
                    )}
                </button>
            </div>
            {isItemsOpen && (
                <div className='mt-4 w-full'>
                    <ul className='list-disc pl-4'>
                        {SavedProducts?.map((product, index) => (
                            <li key={product._id || index} className="text-sm text-gray-700">{product.product_name}</li>
                        ))}
                    </ul>
                </div>
            )}

            <hr className='w-full border-gray-300 my-2' />

            {/* Not Saved Products Section */}
            <div className='flex items-center w-full justify-between cursor-pointer' onClick={toggleSkippedOpen}>
                <h2 className='text-sm font-regular flex items-center'>
                    <FontAwesomeIcon icon={faTimesCircle} className='text-red-500 mr-2 w-4 h-4' />
                    Items NOT Saved: {NotSavedProducts?.length || 0}
                </h2>
                <button className='ml-2 p-1'>
                    {isSkippedOpen ? (
                        <FontAwesomeIcon icon={faChevronDown} className='w-3 h-3' />
                    ) : (
                        <FontAwesomeIcon icon={faChevronRight} className='w-3 h-3' />
                    )}
                </button>
            </div>
            {isSkippedOpen && (
                <div className='mt-4 w-full'>
                    <ul className='list-disc pl-4'>
                        {NotSavedProducts?.map((product, index) => (
                            <li key={product.product_id || product.SKU || index} className="text-sm text-gray-700 mb-1">
                                <span className="font-medium">{product.product_name || 'Unnamed Product'}</span>
                                {/* Note: Ensure your backend maps the failure reason to 'reason' or 'error' */}
                                <span className="text-red-500 ml-2 italic">
                                    - {product.reason || product.error || 'Failed due to validation or missing fields'}
                                </span>
                            </li>
                        ))}
                    </ul>
                </div>
            )}

            <hr className='w-full border-gray-300 my-2' />

            {/* Updated Products Section */}
            <div className='flex items-center w-full justify-between cursor-pointer' onClick={toggleUnmappedOpen}>
                <h2 className='text-sm font-regular flex items-center'>
                    <FontAwesomeIcon icon={faSyncAlt} className='text-[#408DFB] mr-2 w-4 h-4' />
                    Items Updated Successfully: {UpdatedProducts?.length || 0}
                </h2>
                <button className='ml-2 p-1'>
                    {isUnmappedOpen ? (
                        <FontAwesomeIcon icon={faChevronDown} className='w-3 h-3' />
                    ) : (
                        <FontAwesomeIcon icon={faChevronRight} className='w-3 h-3' />
                    )}
                </button>
            </div>
            {isUnmappedOpen && (
                <div className='mt-4 w-full'>
                    <ul className='list-disc pl-4'>
                        {UpdatedProducts?.map((product, index) => (
                            <li key={product._id || index} className="text-sm text-gray-700">{product.product_name}</li>
                        ))}
                    </ul>
                </div>
            )}

            <hr className='w-full border-gray-300 my-2' />
        </div>
    );
};

export default BulkUploadStep3;